<nav class="side-nav">
  <mat-nav-list>
    @for (item of menuItems(); track item.id) {
      @if (!hasChildren(item)) {
        <!-- Simple menu item without children -->
        <a mat-list-item [routerLink]="item.route" routerLinkActive="active">
          @if (item.icon) {
            <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
          }
          <span matListItemTitle>{{ item.label }}</span>
        </a>
      } @else {
        <!-- Menu item with children (expandable) -->
        <mat-expansion-panel class="menu-expansion-panel" [expanded]="isExpanded(item)">
          <mat-expansion-panel-header (click)="toggleExpanded(item, $event)">
            <mat-panel-title class="menu-panel-title">
              @if (item.icon) {
                <mat-icon class="menu-icon">{{ item.icon }}</mat-icon>
              }
              <span>{{ item.label }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          
          <mat-nav-list class="submenu">
            @for (child of item.children; track child.id) {
              <a mat-list-item [routerLink]="child.route" routerLinkActive="active" class="submenu-item">
                @if (child.icon) {
                  <mat-icon matListItemIcon>{{ child.icon }}</mat-icon>
                }
                <span matListItemTitle>{{ child.label }}</span>
              </a>
            }
          </mat-nav-list>
        </mat-expansion-panel>
      }
    }
  </mat-nav-list>
</nav>
